import { CAMERA_TRACK_LIMITS } from '../../domain/camera-keyframes';

export type Orientation = Record<'tilt' | 'roll', number>;
export interface PadDeflection { x: number; y: number }
export const ORIENTATION_RATE = 30;

/** Short displacement acts as pressure; a neutral zone prevents accidental drift. */
export function padDeflection(dx: number, dy: number): PadDeflection {
  const radius = Math.hypot(dx, dy);
  if (radius <= 3) return { x: 0, y: 0 };
  const amount = Math.min(1, (radius - 3) / 29);
  return { x: dx / radius * amount, y: -dy / radius * amount };
}

export function advanceOrientation(values: Orientation, push: PadDeflection, seconds: number): Orientation {
  const bounded = (axis: keyof Orientation, amount: number) => Math.max(CAMERA_TRACK_LIMITS[axis].min,
    Math.min(CAMERA_TRACK_LIMITS[axis].max, values[axis] + amount * ORIENTATION_RATE * Math.max(0, Math.min(.1, seconds))));
  return { tilt: bounded('tilt', push.y), roll: bounded('roll', push.x) };
}
